import store from './../store'

export default async function closeCargo(keepLocalLoadingId = false) {
    // Exit loading
    const loadingCargoId = store.getters.getLoadingCargoId;
    if (!loadingCargoId) {
        return true;
    } else {
        if (!keepLocalLoadingId) {
            store.commit('setLoadingCargoId', null);
        }
        const cargo = store.getters["cargo/getCargo"](loadingCargoId);
        const indexToUpdate = _.findIndex(cargo.opened, { 'closedAt': null, 'userId': store.getters["users/getMeBasic"].userId });
        if (indexToUpdate !== -1) {
            cargo.opened[indexToUpdate].closedAt = new Date();
            await store.dispatch('cargo/patch', {
                id: loadingCargoId,
                opened: cargo.opened
            });
            return true;
        } else {
            return true;
        }
    }
}